import { useParams } from 'react-router';

export const useEmployerParamId = () => {
  const { employerId } = useParams<{ employerId: string }>();

  return employerId;
};
